export const FETCH_RENAME_TEMPLATE_REQUEST = 'FETCH_RENAME_TEMPLATE_REQUEST'
export const FETCH_RENAME_TEMPLATE_SUCCESS = 'FETCH_RENAME_TEMPLATE_SUCCESS'
export const FETCH_RENAME_TEMPLATE_FALUIRE = 'FETCH_RENAME_TEMPLATE_FALUIRE'
